import { z } from 'zod'

export const validatePassword = (password: string): boolean => {
  const hasMinLength = password.length >= 8
  const hasNoKyrillic = !/[А-Яа-яЁё]/.test(password)
  const hasUppercase = /[A-Z]/.test(password)
  const hasLowercase = /[a-z]/.test(password)
  const hasDigit = /[0-9]/.test(password)
  const hasSpecialChar = /[@$!%*?&]/.test(password)

  return hasMinLength && hasNoKyrillic && hasUppercase && hasLowercase && hasDigit && hasSpecialChar
}

export const loginSchema = z.object({
  email: z.string().min(1, { message: 'Логин не может быть ​​пустым' }),
  password: z.string().min(1, { message: 'Пароль не может быть пустым' }).refine(validatePassword, {
    message: 'Невалидный пароль - не соответствует политике паролей',
  }),
})

export type LoginFormValues = z.infer<typeof loginSchema>
